import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ServerDashboardJob } from '../../dashboardType';
import { STATUS_LABELS } from '../../statusLabels';

const StatusCell = ({ data }: CustomCellRendererProps<ServerDashboardJob>) => {
  const status = data?.status;

  if (!status) {
    return null;
  }

  return <>{STATUS_LABELS[status] ?? status}</>;
};

export default StatusCell;
